import { AppState } from '../../..';
import { PropertyManagerSearchComponentProperties } from './property-manager-search.component';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { PropertyManagerSearchComponent } from './property-manager-search.component';
import { propertyManagerSearch } from '../../property-manager.actions';

function mapStateToProps(state: AppState, ownProps: {}): Partial<PropertyManagerSearchComponentProperties> {
  return {
    message: state.propertyManager.errorMessage,
    query: state.propertyManager.query,
    propertyManagers: state.propertyManager.propertyManagers
  };
}

// This should create proxy wrappers for actions used by the component
function mapDispatchToProps(
  dispatch: Dispatch<AppState>,
  ownProps: { isViewOnly: boolean; saveCallback: Function }
): Partial<PropertyManagerSearchComponentProperties> {
  return {
    getPropertyManagerSearch: (query, pageSize, pageNumber, orderBy, orderDirection) =>
      dispatch(propertyManagerSearch(query, pageSize, pageNumber, orderBy, orderDirection))
  };
}

// Connect function "wires" both of the map functions and returns a wrapper container for the component
export const PropertyManagerSearch = connect(
  mapStateToProps,
  mapDispatchToProps
)(PropertyManagerSearchComponent);



// WEBPACK FOOTER //
// ./src/property-manager/_components/property-manager-search/property-manager-search.container.ts